export default __webpack_public_path__ + "static/media/BANNER_principalBOTON_scania_volveralfuturo.444ec861.jpg";